import React from 'react';
import { injectIntl } from 'react-intl';
import { Table } from 'react-bootstrap';
import { orderBy as _orderBy } from 'lodash';

import IntlDateTime from 'components/layout/IntlDateTime';

class CrStatsDetails extends React.Component {
  render() {
    const {
      intl: { messages },
      data,
    } = this.props;

    return (
      <Table responsive hover condensed>
        <thead>
          <tr>
            <th>{messages.client_name}</th>
            <th>{messages.count}</th>
            <th>{messages.won}</th>
            <th>{messages.lost}</th>
            <th>{messages.sad.conversion_rate}</th>
            <th>{messages.latest_lead}</th>
            <th>{messages.latest_edit}</th>
          </tr>
        </thead>
        <tbody>
          {_orderBy(data, ['cr', 'name'], ['desc', 'asc']).map(entry => {
            return (
              <tr key={entry.id}>
                <td>{entry.name}</td>
                <td>{entry.count}</td>
                <td>{entry.won}</td>
                <td>{entry.lost}</td>
                <td>{entry.cr}%</td>
                <td>
                  <IntlDateTime date={entry.last_lead} />
                </td>
                <td>
                  <IntlDateTime date={entry.last_edit} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}
CrStatsDetails.defaultProps = {};

export default injectIntl(CrStatsDetails);
